import {
	ClientPortfolioPaymentFrequencyEnum,
	type PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { DayData } from "web_myplann/Portfolio/Helpers/calculateGraphData";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";
import { EMPTY_DETAIL_FIELD } from "web_myplann/Utils/constants";

export const getPortfolioValueDate = (
	daysData: DayData[],
	baseData: PortfolioDetailResponseDTO,
) =>
	daysData.length > 0
		? dateFormatter(baseData.portfolioValueDate ?? new Date())
		: EMPTY_DETAIL_FIELD;

export const getPortfolioFrequencyValue = (
	value: number | null | undefined,
	currencySign: string,
	paymentFrequency: ClientPortfolioPaymentFrequencyEnum | null,
	t: (key: string) => string,
	decimal?: number,
) =>
	value
		? `${moneyFormatter(value, currencySign, undefined, decimal)} ${t(Resources.PortfolioDetail.SharedLabels.Frequency[paymentFrequency ?? ClientPortfolioPaymentFrequencyEnum.None]).toLowerCase()}`
		: EMPTY_DETAIL_FIELD;
